import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=9a61c066&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=ts"
export * from "./EventDetail.vue?vue&type=script&lang=ts"
import style0 from "./EventDetail.vue?vue&type=style&index=0&id=9a61c066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a61c066",
  null
  
)

export default component.exports